import { registerPlugin } from '@capacitor/core';

export interface HomeLauncherPlugin {
  setAsHome(): Promise<void>;
  isDefaultHome(): Promise<{ value: boolean }>;
}

const HomeLauncher = registerPlugin<HomeLauncherPlugin>('HomeLauncher', {
  web: () => import('./homeLauncher.web').then(m => new m.HomeLauncherWeb()),
});

export default HomeLauncher;
